import { isObjectEmpty } from 'src/utils/aem-utils/utils';
import { ValidationOutcomes, ValidationResult } from '.';

const isButtonPropValid = (buttonProps: any): ValidationResult => {
  const vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
    componentProps: null,
  };

  if (isObjectEmpty(buttonProps)) {
    vr.messages.push('Button props are empty. {}');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  vr.result = ValidationOutcomes.SUCCESS;
  vr.componentProps = buttonProps;
  return vr;
};

export default isButtonPropValid;
